import React from "react";
import styled from "styled-components";

import UIDropdown from "components/UI/Dropdown";
import UIButtonSecondary from "components/UI/Button/Secondary";
import UIPrimaryWidgetBox from "components/UI/PrimaryWidgetBox";
import UITable from "components/UI/Table";

const Container = styled.div.attrs({ className: "costs-table" })`
  .head {
    display: flex;
    justify-content: space-between;
  }

  .control {
    display: inline-block;
  }

  .dropdown input {
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .export-btn {
    height: 36px;
    font-weight: bold;
    padding: 6px 34px;
  }

  th {
    background: ${props => props.theme.colors.white};
    border-bottom: ${props => `1px solid ${props.theme.colors.silverAlt}`};
    border-top: ${props => `1px solid ${props.theme.colors.silverAlt}`};
    border-right: ${props => `1px solid ${props.theme.colors.silverAlt}`};
    color: ${props => props.theme.colors.mako};
    font-weight: bold;
    text-align: left;
  }

  .var::after {
    content: "%";
  }
  .var.up {
    color: ${props => props.theme.colors.grassland};
  }
  .var.down {
    color: ${props => props.theme.colors.monza};
  }
  .var.up::before,
  .var.down::before {
    background: url("/assets/images/icon--arrow.svg") no-repeat;
    background-size: contain;
    content: " ";
    display: inline-block;
    height: 10px;
    width: 11px;
  }
  .var.up::before {
    transform: rotate(90deg);
  }
  .var.down::before {
    transform: rotate(-90deg);
  }
`;

const getVarClass = number =>
  number > 0 ? "up" : number < 0 ? "down" : "neutral";

const AnalyticsDashboardCostsTable = ({ className }) => {
  return (
    <Container className={className}>
      <UIPrimaryWidgetBox className="p">
        <div className="head">
          <div className="control">
            <UIDropdown
              initialSelectedItem={{
                value: "Average Cost",
                text: "Average Cost"
              }}
              className="naked"
              options={[{ value: "Average Cost", text: "Average Cost" }]}
            />
          </div>
          <UIButtonSecondary className="export-btn">
            Export Report
          </UIButtonSecondary>
        </div>

        <UITable className="mt">
          <UITable.Header>
            <UITable.Row>
              <UITable.HeaderCell>Period</UITable.HeaderCell>
              <UITable.HeaderCell>Current Year</UITable.HeaderCell>
              <UITable.HeaderCell>Last Year</UITable.HeaderCell>
              <UITable.HeaderCell>Variation</UITable.HeaderCell>
            </UITable.Row>
          </UITable.Header>
          <UITable.Body>
            <UITable.Row>
              <UITable.Cell>Month</UITable.Cell>
              <UITable.Cell>98</UITable.Cell>
              <UITable.Cell>100</UITable.Cell>
              <UITable.Cell>
                <span className={`var ${getVarClass(2)}`}>2</span>
              </UITable.Cell>
            </UITable.Row>
            <UITable.Row>
              <UITable.Cell>Rolling 3 Months</UITable.Cell>
              <UITable.Cell>124</UITable.Cell>
              <UITable.Cell>120</UITable.Cell>
              <UITable.Cell>
                <span className={`var ${getVarClass(-2)}`}>2</span>
              </UITable.Cell>
            </UITable.Row>
            <UITable.Row>
              <UITable.Cell>Year to Date</UITable.Cell>
              <UITable.Cell>194</UITable.Cell>
              <UITable.Cell>140</UITable.Cell>
              <UITable.Cell>
                <span className={`var ${getVarClass(8)}`}>8</span>
              </UITable.Cell>
            </UITable.Row>
            <UITable.Row>
              <UITable.Cell>Rolling Year</UITable.Cell>
              <UITable.Cell>60</UITable.Cell>
              <UITable.Cell>88</UITable.Cell>
              <UITable.Cell>
                <span className={`var ${getVarClass(-4)}`}>4</span>
              </UITable.Cell>
            </UITable.Row>
          </UITable.Body>
        </UITable>
      </UIPrimaryWidgetBox>
    </Container>
  );
};

export default AnalyticsDashboardCostsTable;
